.footer {
  display: flex;
  min-height: 220px;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  /* horizontal padding lives on the inner blocks (below) so the footer content
     lines up with the page body's centered 1240px column, not the full width */
  padding: 1.5rem 0;
  background-color: var(--footer-bg-color);
  grid-area: footer;
}

/* Match the page body / header: centered 1240px column with 24px gutters */
.footerText,
.footerTextBottom,
.footerDivider {
  width: 100%;
  max-width: 1240px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 24px;
}

.footerText {
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
}

.footerTextBottom {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.footerContact {
  margin-top: 1.5rem;
}

.footerAddress {
  display: flex;
  flex-direction: column;
}

/* legal links: muted by default (set inline), brick-red on hover.
   !important is required to override Text's inline color style. */
.footerLink {
  padding: 0;
  text-align: left;
  transition: color 0.15s ease;
}

.footerLink:hover span {
  color: var(--ib-red) !important;
}

.footerDivider {
  height: 1px;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border-top: 1px solid #d2d2d7;
}
